import { Col, Form, Row, Button, Image, Modal, Tabs, Tab } from "react-bootstrap";
import { useFormik } from "formik";
import { useState, useEffect, useMemo } from "react";
import { AddProductEntrepreneur, getAllRibbonBadges, getAllPartiners } from "../../services/api";
import { AddProductSchema } from "../../utils/validation_schemas";
import { createProductFormData } from "../../utils/payloads";
import ErrorAlert from "../ErrorAlert";
import useNotification from "../../contexts/notification";
import { formatDate } from "../../utils/formatters";
import useCategories from "../../hooks/useCategories";
import { InputGroup } from "react-bootstrap";
import { MdContentCopy, MdCheck, MdLocalOffer } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import Select from 'react-select';
import ProductImageGalleryModal from "../ProductImageGalleryModal";
export default function AddProductForm({ onSubmit }) {
  const navigate = useHistory();
  const [status, setStatus] = useState("start");
  const clearStatus = () => setStatus({ status: "start" });
  const { setMessage } = useNotification();
  const [partners, setPartners] = useState([]);
  const categories = useCategories();
  const [newProduct, setNewProduct] = useState(null);
  const [shortUrl, setShortUrl] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const groupedCategoryOptions = useMemo(() => {
    return categories.map((category) => ({
      label: category.name,
      options: category.category_types.map((sub) => ({
        label: sub.name,
        value: sub.id,
      })),
    }));
  }, [categories]);
  const [submitting, setSubmitting] = useState(false);
  const [badge, setBadge] = useState([]);
  const [imageTabKey, setImageTabKey] = useState("upload");
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);
  const [isApplyingGalleryImage, setIsApplyingGalleryImage] = useState(false);
  const findCategoryName = (id) => {
    const idNumber = Number(id); // converte para número
    for (const group of groupedCategoryOptions) {
      const match = group.options.find(opt => Number(opt.value) === idNumber);
      if (match) return match.label;
    }
    return id; // fallback
  };

  const handleOpenGallery = () => {
    setShowGalleryModal(true);
  };

  const handleCloseGallery = () => {
    if (!isApplyingGalleryImage) {
      setShowGalleryModal(false);
    }
  };

  const handleImageUploadChange = (event) => {
    const file = event.currentTarget.files?.[0];
    setSelectedGalleryImage(null);
    setImageTabKey("upload");
    formik.setFieldValue("image", file);
  };

  const handleSelectGalleryImage = async (image) => {
    setIsApplyingGalleryImage(true);

    try {
      const response = await fetch(image.url);
      const blob = await response.blob();
      const fileName = image.file_name || `imagem-${image.id}.jpg`;
      const file = new File([blob], fileName, {
        type: blob.type || "image/jpeg",
      });

      formik.setFieldValue("image", file);
      formik.setFieldTouched("image", true, false);
      setSelectedGalleryImage(image);
      setImageTabKey("gallery");
      setShowGalleryModal(false);
    } catch (error) {
      console.error("Erro ao selecionar imagem da galeria", error);
      setMessage({
        error: true,
        content: "Não foi possível carregar a imagem selecionada.",
      });
    } finally {
      setIsApplyingGalleryImage(false);
    }
  };

  useEffect(() => {

    getAllRibbonBadges().then((data) => {

      setBadge(data);
    });
  }, []);

  useEffect(() => {
    getAllPartiners().then((data) => {

      setPartners(data);
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      image: undefined,
      previous_price: "",
      link: "",
      partner_id: null,
      have_cupom: "0",
      send_notifications: "0",
      title: "",
      ribbon_badges: "0",
      category_type_id: null,
      cupom: "",
      cupom_validity: "",
      price_on_offer: "0",
      min_quantity_wholesale: "",
      offer_price: "",

    },
    validationSchema: AddProductSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values, { resetForm }) => {
      setSubmitting(true);
      try {
        const resp = await AddProductEntrepreneur(createProductFormData(values));

        setNewProduct(resp.product);
        setShortUrl(resp.shortUrl);
        setShowConfirmModal(true);

        setMessage({
          error: false,
          content: resp.msg || "Produto adicionado com sucesso",
        });

        resetForm(); // 🔹 limpa os campos do formulário
        setSelectedGalleryImage(null);
        setImageTabKey("upload");
      } catch (e) {
        setMessage({
          error: true,
          content: "Erro ao adicionar produto",
        });
      }
      setSubmitting(false);
    },
  });

  return (
    <>
      <Form onSubmit={formik.handleSubmit} className="mt-3">
        <h6 className="mb-3 text-primary">Dados do produto</h6>
        <Form.Group className="mt-1 mb-4" >
          <Row>
            <Col xl={8} md={8}>
              <Form.Label>Nome do produto</Form.Label>
              <Form.Control
                className="my-1"
                type="text"
                name="name"
                placeholder="Nome do produto"

                onChange={formik.handleChange}
                value={formik.values.name}
                isValid={formik.touched.name && !formik.errors.name}
                isInvalid={formik.errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.name}
              </Form.Control.Feedback>
            </Col>

            <Col xl={4} md={4} sm={5}>
              <Form.Label>Preço Anterior *</Form.Label>
              <NumericFormat
                name="previous_price"
                value={formik.values.previous_price}
                thousandSeparator="."
                decimalSeparator=","
                allowNegative={false}
                isNumericString
                onValueChange={({ floatValue }) => {
                  formik.setFieldValue("previous_price", floatValue ?? "");
                }}
                customInput={Form.Control}
                className="my-1"
                placeholder="Preço Anterior"
                isInvalid={!!formik.errors.previous_price}
                isValid={
                  formik.touched.previous_price && !formik.errors.previous_price
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.previous_price}
              </Form.Control.Feedback>

            </Col>
            <Col xl={6} md={6} sm={6}>
              <Form.Label>Preço da Oferta *</Form.Label>
              <NumericFormat
                name="offer_price"
                value={formik.values.offer_price}
                thousandSeparator="."
                decimalSeparator=","
                allowNegative={false}
                isNumericString
                onValueChange={({ floatValue }) => {
                  formik.setFieldValue("offer_price", floatValue ?? "");
                }}
                customInput={Form.Control}
                className="my-1"
                placeholder="Preço de Oferta"
                isInvalid={!!formik.errors.offer_price}
                isValid={
                  formik.touched.offer_price && !formik.errors.offer_price
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.offer_price}
              </Form.Control.Feedback>
              <Form.Check
                className="my-1"
                type="checkbox"
                name="price_on_offer"
                label="Preço em Oferta"
                onChange={(e) => {
                  formik.setFieldValue("price_on_offer", e.target.checked ? "1" : "0");

                }}
                value={formik.values.price_on_offer === "1"}
              />
            </Col>
            <Form.Group>
              <h6 className="mb-3 text-primary center">Emblemas no Produto</h6>
              <fieldset>
                <h6 className="text-danger">{formik.errors.ribbon_badges}</h6>
                <Row>
                  {badge.map((f) => {
                    return (
                      <Col className="center" sm={12} md={6} lx={6} key={f.id}>
                        <Form.Check
                          custom
                          id={`custom-checkbox-${f.id}`}
                          name="ribbon_badges"
                          type="radio"
                          isInvalid={
                            formik.errors.ribbon_badges &&
                              formik.touched.ribbon_badges
                              ? true
                              : false
                          }
                          value={f.id}
                          label={f.name}
                          required={formik.values.ribbon_badges.length === 0}
                          checked={formik.values.ribbon_badges.includes(
                            String(f.id)
                          )}
                          onChange={formik.handleChange}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </fieldset>
            </Form.Group>

            <Col xl={12} md={12} sm={12}>
              <Form.Label>Descrição *</Form.Label>
              <Form.Control
                className="my-1"
                as="textarea"
                rows={3}
                name="description"
                placeholder="Descrição do produto"
                onChange={formik.handleChange}
                value={formik.values.description}
                isValid={formik.touched.description && !formik.errors.description}
                isInvalid={formik.errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.description}
              </Form.Control.Feedback>
            </Col>
            <Form.Group className="mt-3">
              <Tabs
                activeKey={imageTabKey}
                onSelect={(key) => setImageTabKey(key || "upload")}
                className="product-image-tabs"
              >
                <Tab eventKey="upload" title="Fazer upload">
                  <div className="pt-3">
                    <Form.File
                      accept="image/avif,image/webp,image/png,image/jpeg"
                      name="image"
                      lang="pt"
                      label={
                        formik.values.image
                          ? formik.values.image.name
                          : "Escolher arquivo"
                      }
                      onChange={handleImageUploadChange}
                      isInvalid={formik.errors.image}
                      feedback={formik.errors.image}
                      custom
                    />
                  </div>
                </Tab>
                <Tab eventKey="gallery" title="Galeria de imagens">
                  <div className="pt-3">
                    <p className="text-muted mb-3">
                      Busque imagens já utilizadas para reutilizar no produto.
                    </p>
                    <Button
                      variant="outline-primary"
                      type="button"
                      onClick={handleOpenGallery}
                      disabled={isApplyingGalleryImage}
                    >
                      Buscar imagem
                    </Button>
                    {isApplyingGalleryImage && (
                      <span className="text-muted small ms-3">
                        Carregando imagem selecionada…
                      </span>
                    )}
                  </div>
                </Tab>
              </Tabs>
              {selectedGalleryImage && (
                <div className="mt-4">
                  <Form.Label className="d-block">Imagem selecionada</Form.Label>
                  <div
                    className="p-3 bg-light border rounded d-inline-flex flex-column align-items-center"
                    style={{ minWidth: "200px" }}
                  >
                    <Image
                      src={selectedGalleryImage.thumbnail_url || selectedGalleryImage.url}
                      alt={selectedGalleryImage.product_name || selectedGalleryImage.file_name}
                      rounded
                      style={{ width: "160px", height: "120px", objectFit: "cover" }}
                    />
                    <small className="text-muted mt-2 text-center">
                      {selectedGalleryImage.product_name || selectedGalleryImage.file_name}
                    </small>
                  </div>
                </div>
              )}
            </Form.Group>



            <Col xl={12} md={12} sm={12}>
              <Form.Label>Link de Oferta</Form.Label>
              <Form.Control
                className="my-1"
                type="url"
                name="link"
                placeholder="http://exemplo-de-oferta.com"
                onChange={formik.handleChange}
                value={formik.values.link}
                isInvalid={!!formik.errors.link}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.link}
              </Form.Control.Feedback>
            </Col>


            <Col xl={6} md={6} sm={6}>
              <Form.Label>Parceiros *</Form.Label>
              <Select
                id="partner_id"
                name="partner_id"
                options={partners.map(partner => ({
                  value: partner.id,
                  label: partner.name
                }))}
                value={
                  partners
                    .map(partner => ({ value: partner.id, label: partner.name }))
                    .find(option => option.value === formik.values.partner_id) || null // 👈 aqui
                }
                onChange={option =>
                  formik.setFieldValue('partner_id', option ? option.value : null)
                }
                onBlur={() => formik.setFieldTouched('partner_id', true)}
                placeholder="Selecione um parceiro"
                noOptionsMessage={() => "Nenhum parceiro encontrado"}
                classNamePrefix="select"
              />

              {formik.touched.partner_id && formik.errors.partner_id && (
                <div className="invalid-feedback d-block">
                  {formik.errors.partner_id}
                </div>
              )}
            </Col>

            <Col xl={6} md={6} sm={6}>
              <Form.Group>
                <Form.Label>Subcategoria *</Form.Label>
                <Select
                  options={groupedCategoryOptions}
                  name="category_type_id"
                  value={
                    groupedCategoryOptions
                      .flatMap(group => group.options)
                      .find(option => option.value === formik.values.category_type_id) || null // 👈 aqui
                  }
                  onChange={option =>
                    formik.setFieldValue('category_type_id', option ? option.value : null)
                  }
                  onBlur={() => formik.setFieldTouched('category_type_id', true)}
                  placeholder="Selecione uma subcategoria"
                  noOptionsMessage={() => "Nenhuma subcategoria encontrada"}
                  classNamePrefix="select"
                />

                {formik.touched.category_type_id && formik.errors.category_type_id && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.category_type_id}
                  </div>
                )}
              </Form.Group>
            </Col>






            <Col xl={6} md={6} sm={6}>
              <Form.Label>Cupom *</Form.Label>
              <Form.Control
                className="my-1"
                type="text"
                name="cupom"
                placeholder="Cupom Disponivel"
                onChange={formik.handleChange}
                value={formik.values.cupom}
                isValid={formik.touched.cupom && !formik.errors.cupom}
                isInvalid={formik.errors.cupom}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.cupom}
              </Form.Control.Feedback>
            </Col>

            <Col xl={6} md={6} sm={6}>
              <Form.Label>Data de expiração do Cupom *</Form.Label>
              <Form.Control
                className="my-1"
                type="date"
                name="cupom_validity"
                min={formatDate(new Date())}
                placeholder="Data de expiração do Cupom"
                onChange={formik.handleChange}
                value={formik.values.cupom_validity}
                isValid={
                  formik.touched.cupom_validity &&
                  !formik.errors.cupom_validity
                }
                isInvalid={formik.errors.cupom_validity}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.cupom_validity}
              </Form.Control.Feedback>
            </Col>



          </Row>

          {status === "error" && (
            <ErrorAlert msg="Um erro ocorreu." onClose={clearStatus} />
          )}
          <Col>
            <Form.Check
              className="my-1"
              type="checkbox"
              name="send_notifications"
              label="Enviar Notificações?"
              onChange={(e) => {
                formik.setFieldValue("send_notifications", e.target.checked ? "1" : "0");

              }}
              value={formik.values.send_notifications === "1"}
            />
            {formik.values.send_notifications == "1" && (

              <Form.Group controlId="formTitle">

                <Form.Control
                  type="text"
                  name="title"
                  placeholder="Digite o título"
                  onChange={formik.handleChange}
                  value={formik.values.title}
                />
              </Form.Group>

            )}
            <Row>
              <Button
                className="my-2"
                variant="primary"
                type="submit"
                disabled={submitting}
              >
                Adicionar
              </Button>
            </Row>

          </Col>
        </Form.Group>
      </Form>
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold fs-5" style={{ fontFamily: "Inter" }}>
            Publicação adicionada
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {newProduct && (
            <>
              <p>
                <strong>Título:</strong> {newProduct.name}
              </p>
              <p>
                <strong>Categoria:</strong>{" "}
                {findCategoryName(newProduct.category_type_id)}
              </p>
              <p>
                <strong>Preço atual:</strong> R$ {newProduct.offer_price}
              </p>

              {/* Input + ticket + botão copiar */}
              <InputGroup>
                {/* Ícone de ticket à esquerda */}
                <InputGroup.Text
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 0 0 8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MdLocalOffer size={20} color="#0052B3" />
                </InputGroup.Text>

                <Form.Control
                  type="text"
                  value={shortUrl}
                  readOnly
                  style={{
                    fontWeight: "500",
                    color: "#0052B3",
                    fontFamily: "Inter",
                  }}
                />

                <Button
                  variant="outline-secondary"
                  style={{
                    borderRadius: "0 8px 8px 0",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(shortUrl);
                    setCopied(true); // muda ícone
                    setMessage({ error: false, content: "Link copiado!" });
                    setTimeout(() => setCopied(false), 2000); // volta ícone depois de 2s
                  }}
                >
                  {copied ? (
                    <MdCheck size={18} color="green" />
                  ) : (
                    <MdContentCopy size={18} color="#0052B3" />
                  )}
                </Button>
              </InputGroup>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => window.open(shortUrl, "_blank")}
            style={{
              borderRadius: "20px",
              padding: "6px 20px",
              fontWeight: "bold",
              fontFamily: "Inter",
              backgroundColor: "#0052B3",
              border: "none",
            }}
          >
            Ver Post
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
            style={{
              borderRadius: "20px",
              padding: "6px 20px",
              fontWeight: "bold",
              fontFamily: "Inter",
              backgroundColor: "white",
              border: "1px solid #ddd",
              color: "#0052B3",
            }}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <ProductImageGalleryModal
        show={showGalleryModal}
        onHide={handleCloseGallery}
        onSelect={handleSelectGalleryImage}
        selectedImageId={selectedGalleryImage?.id}
        isConfirmingSelection={isApplyingGalleryImage}
      />


    </>
  );
}
